/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "angularMoment" }]*/

// Eagerly require all templates from all modules
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./', true, /^(?!.*\/index\.html$).*\.html$/));

// Favicon. Import any other image manually.
import './favicon.png';

// Lib + App SCSS
import './index.scss';

// eslint-disable-next-line no-unused-vars
import style from 'angular-ui-carousel/dist/ui-carousel.css';

// Lib
import angular from 'angular';
import angularAnimate from 'angular-animate';
import angularCookies from 'angular-cookies';
import angularMessages from 'angular-messages';
import angularMaterial from 'angular-material';
import angularResource from 'angular-resource';
import angularRoute from 'angular-route';
import angularSanitize from 'angular-sanitize';
import angularMoment from 'angular-moment';
import ngclipboard from 'ngclipboard';

// eslint-disable-next-line no-unused-vars
import angularUiCarousel from 'angular-ui-carousel/dist/ui-carousel.js';

// App modules
import authModule from './auth/auth-module';
import configModule from './config/config-module';
import formsModule from './forms/forms-module';
import signupBasicModule from './signup-basic/signup-basic-module';
import loginModule from './login/login-module';
import logoutModule from './logout/logout-module';
import passwordModule from './password/password-module';
import userModule from './user/user-module';
import activateModule from './activate/activate-module';
import dataModule from './data/data-module';
import utilsModule from './utils/utils-module';
import paymentsModule from './payments/payment-module';

export default angular.module('main', [
    // Libs
    angularAnimate,
    angularCookies,
    angularMessages,
    angularMaterial,
    angularResource,
    angularRoute,
    angularSanitize,
    'angularMoment',
    ngclipboard,
    'ui.carousel',

    // App modules
    authModule,
    configModule,
    formsModule,
    signupBasicModule,
    loginModule,
    logoutModule,
    passwordModule,
    userModule,
    activateModule,
    dataModule,
    utilsModule,
    paymentsModule
]).name;



// WEBPACK FOOTER //
// ./index.js